import { render, staticRenderFns } from "./XeroContactCard.vue?vue&type=template&id=2d502519&scoped=true"
import script from "./XeroContactCard.vue?vue&type=script&lang=js"
export * from "./XeroContactCard.vue?vue&type=script&lang=js"
import style0 from "./XeroContactCard.vue?vue&type=style&index=0&id=2d502519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d502519",
  null
  
)

export default component.exports